<template>
    <section class="card job-tags-section">
        <div class="section-header">
            <h3>{{ $trans("web_profile.job_tags") }}</h3>
            <EditButton :onClick="WebProfileStore.openEditJobTagsModal" />
        </div>

        <div class="tags-grid">
            <template
                v-for="tag in WebProfileStore.jobTags"
                :key="tag.id"
            >
                <div class="profile-card-sector-item">
                    <div class="title">
                        {{ tag.name }} /
                        <span class="title-duration">{{ tag.duration }}</span>
                    </div>
                    <ProfileProgressBar
                        :percentage="tag.duration_percentage"
                        :main-filters="mainFilters"
                        :tag-id="tag.id"
                    />
                </div>
            </template>
        </div>

        <EditJobTagsModal />
    </section>
</template>

<script>
import { mapStores } from "pinia";
import { useWebProfileStore } from "@/stores/WebProfileStore";
import EditJobTagsModal from "./Modals/EditJobTagsModal.vue";
import ProfileProgressBar from "./../Components/ProgressBar.vue";
import EditButton from "./../Components/EditButton.vue";

export default {
    name: "JobTagsSection",
    components: {
        EditJobTagsModal,
        ProfileProgressBar,
        EditButton,
    },
    props: {
        mainFilters: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        ...mapStores(useWebProfileStore),
    },
};
</script>

<style scoped>
.job-tags-section {
    padding: 20px;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}
h3 {
    margin: 0;
    font-size: 1.875rem;
    font-weight: 600;
}

.tags-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
}

.title {
    font-weight: 700;
    color: #000;
    margin-bottom: 8px;
    font-size: 16px;
}

.el-button {
    background-color: #41abc4;
    border-color: #41abc4;
}
</style>